import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { isPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import { isEnded } from '../utils';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { sortDocumentsDescending } from 'Utility/documentHandling';

const fm = (id: string, values?: { [key: string]: string | number | null }, key?: string): React.JSX.Element => (
  <FormattedMessage id={id} values={values} key={key} />
);

const OtherSymptomsDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const docs = documents.sort(sortDocumentsDescending);
  const ongoingSymptoms = docs.filter(d => !isEnded(d.endDate));
  const endedSymptoms = docs.filter(d => isEnded(d.endDate));

  return (
    <TileContentMaker
      type="recentList"
      data={[...ongoingSymptoms, ...endedSymptoms].map(s => ({
        date: isPartialDate(s.date) ? formatPartialDate(s.date) : '',
        title: s.classification ? (
          <React.Fragment>
            <span>{fm(`otherSymptoms.${s.classification}.title`)}</span>
            {s.symptoms && <span>: {fm(`otherSymptoms.${s.classification}.opts.${s.symptoms}`)}</span>}
            {s.symptoms === 'other' && s.freeText && <span> ({s.freeText})</span>}
          </React.Fragment>
        ) : (
          '-'
        ),
        endDate: isPartialDate(s.endDate) ? formatPartialDate(s.endDate) : '',
        key: s._id,
      }))}
    />
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'otherSymptoms'>[];
}

export default OtherSymptomsDash;
